const ForwardArrowWithBar = () => (
  <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.5 9H15.5M15.5 9L11 4.5M15.5 9L11 13.5"
      stroke="#101828"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ForwardArrowWithBar;
